
function Signup() {
  return (
    <section>
      <div className="sign-up">
        <div className="info-text">
          <h3>Want to join Away Days?</h3>
          <br/>
          <p>Find out the best pubs and other attractions in the area for your perfect away day.</p>
          <br/>
          <a href="/register">
            <button className="button">
              Sign Up Today
            </button>
          </a>
        </div>
      </div>

    </section>
  )
}

export default Signup 